import React, { Component } from 'react';
import StudyList from '../../components/study/studyList';
import EditStudy from '../../components/study/editStudy';
import ViewInvitesPage from '../../components/Invites';
import {connect} from 'react-redux';
import {fetchAllStudy, editStudy, updateStudy, getViewInvites, backInvites} from '../../actions/study';
class StudyLists extends Component {
  constructor(props){
    super(props)
    this.state = {
    }
    this.createStudy = this.createStudy.bind(this);
    this.editStudy = this.editStudy.bind(this);
    this.studyList = this.studyList.bind(this);
    this.updateStudy= this.updateStudy.bind(this);
    this.viewInvites= this.viewInvites.bind(this);
    this.backInvites = this.backInvites.bind(this);
    
  }

  componentWillMount() {
 let token=sessionStorage.getItem("adminToken");
     if(token){
      this.props.dispatch(fetchAllStudy( token));
    }
  }

  createStudy(){
    this.props.history.push('/study');
  }

  editStudy(data){
    this.props.dispatch(editStudy(data));
  }

  studyList(){
    let token=sessionStorage.getItem("adminToken");
     if(token){
      this.props.dispatch(fetchAllStudy(token));
    }
  }

  updateStudy(data){  
      this.props.dispatch(updateStudy(data));
  }

  viewInvites(data){
    this.props.dispatch(getViewInvites(data));
  }

  backInvites(){
    this.props.dispatch(backInvites());
  }

  render() {
    if(!this.props.authenticated){
      let adminPassword=sessionStorage.getItem("adminPassword");
         let adminEmail=sessionStorage.getItem("adminEmail");
          if(adminPassword && adminEmail){
           // this.props.dispatch(fetchAllStudy( adminEmail));
         }else {
           alert("Please login.");
           this.props.history.push("login");
         }
  }

   let StudyListHtml ="";
   let editStudy = "";
   let showInvites = "";
   if(this.props.showStudyList){

    if(this.props.showInvitesData){
      showInvites =  <ViewInvitesPage 
                      invitesDataResponse = {this.props.invitesDataResponse}
                      backInvites = {this.backInvites}
                      />
    }else{
      StudyListHtml =   <StudyList
                        viewInvites = {this.viewInvites}
                        getStudyData = {this.getStudyData}
                        studies  ={this.props.studies}
                        studyMessage = {this.props.studyMessage}
                        createStudy = {this.createStudy}
                        editStudy = {this.editStudy}
                               />
    }

     
   }else if(this.props.showEditStudy){
          editStudy = <EditStudy
                      editStudyData = {this.props.editStudyData}
                      studyList = {this.studyList}
                      updateStudy = {this.updateStudy}
                      updateResponse = {this.props.updateResponse}
                        />
   }

   return (<div>
          {StudyListHtml}
          {editStudy}
          {showInvites}
           </div>

   );
  }
}

const  mapStateToProps =(state) =>{
  return {
        studies : state.study.studies,
        studyMessage : state.study.studyMessage,
        authenticated : state.login.authenticated,
        showStudyList: state.study.showStudyList,
        editStudyData : state.study.editStudyData,
        showEditStudy : state.study.showEditStudy,
        updateResponse : state.study.updateResponse,
        showInvitesData: state.study.showInvitesData,
        invitesDataResponse: state.study.invitesDataResponse
  }
}

export default connect(mapStateToProps)(StudyLists);



// WEBPACK FOOTER //
// ./src/pages/study/studyLists.js